import { Component,EventEmitter,Output,ViewChild } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';
import { ModalBase } from 'src/app/model/modal-base';
import { ResourceService, PriceService } from '../../../../services';
import { TrackingFacadeService } from 'src/app/services/tracking/tracking-facade.service';

@Component({
    selector: 'app-confirm-remove-modal',
    templateUrl: './confirm-remove-modal.component.html',
    styleUrls: ['./confirm-remove-modal.component.scss'],
    // encapsulation: ViewEncapsulation.None
})
export class ConfirmRemoveModalComponent //extends ModalBase
{
    @Output() public onConfirmRemoval = new EventEmitter();
    @Output() public onRejectRemoval = new EventEmitter();

    private readonly priceService: PriceService;
    private readonly resourceService: ResourceService;
    private readonly trackingFacadeService: TrackingFacadeService;

    public constructor(
        priceService: PriceService,
        resourceService: ResourceService,
        trackingFacadeService: TrackingFacadeService
    )
    {
        this.priceService = priceService;
        this.resourceService = resourceService;
        this.trackingFacadeService = trackingFacadeService;
    }

    @ViewChild('modal', { static: true })
    public modal: ModalComponent;
    public productData: any;
    public isPackage: boolean;
    public name = '';
    public iconUrl = '';
    public topPrize = '';
    public minPrize = '';

    public open(isPackage: boolean, data: any): void
    {
        this.isPackage = isPackage
        this.modal.open();
        this.productData = data;

        this.name = isPackage ? data.TicketPackage.Name : data.Type.Name;
        this.iconUrl = this.resourceService.getString(`shop_ticket_image_url_${this.name}`),
        this.topPrize = this.resourceService.getString(`global_package_topprize_text_${this.name}`)
        this.minPrize = this.resourceService.getString(`global_package_minprize_text_${this.name}`)
        // Modal open/close is tracked centrally in ModalService (every ngb-modal-window modal).
    }

    public closeModal(): void
    {
        this.modal.close();
        this.iconUrl = ''
    }

    public confirmRemoval(productData): void
    {
        this.trackingFacadeService.basketConfirmRemoveItemClick(this.isPackage);
        this.onConfirmRemoval.emit({isPackage: this.isPackage, data: productData})
    }
    public rejectRemoval(): void
    {
        this.onRejectRemoval.emit()
    }
}
